/*
The article intro is the post's first Ghost callout card, and only when it is
the very first thing in the content: its rich text moves into the header slot
and the card is removed from the body. No leading callout means no intro —
that is the per-post switch.
*/

export default function intro() {
    const slot = document.querySelector('.intro-slot');
    const content = document.querySelector('.gh-content');

    if (!slot || !content || slot.firstElementChild) {
        return;
    }

    const first = content.firstElementChild;

    if (!first || !first.classList.contains('kg-callout-card')) {
        return;
    }

    const text = first.querySelector('.kg-callout-text');

    if (!text || !text.textContent.trim()) {
        return;
    }

    // The emoji and the callout's background colour are not part of the intro
    text.querySelectorAll('.kg-callout-emoji').forEach((emoji) => emoji.remove());

    const paragraph = document.createElement('p');
    paragraph.className = 'intro';
    paragraph.innerHTML = text.innerHTML.trim();

    slot.appendChild(paragraph);
    first.remove();
}
